import { createFileRoute } from "@tanstack/react-router";

import { BranchesTable } from "@/components/BranchesTable";

export const Route = createFileRoute(
  "/_authenticated/organisations/$slug/branches/",
)({
  component: BranchesPage,
});

function BranchesPage() {
  const { slug } = Route.useParams();

  return <BranchesTable organisationSlug={slug} />;
}
